import type { DowngradeTypeT } from "../models/models";

const getTextKeysForModal = (downgradeType: DowngradeTypeT) => {
  const title = downgradeType.includes("addon")
    ? `title-${downgradeType}-downgrade-not-allowed`
    : "title-subscription-plan-downgrade-not-allowed";

  const description = `description-${downgradeType}-downgrade-not-allowed`;

  let manageButton;
  let manageButtonLink;

  switch (downgradeType) {
    case "forms":
      manageButton = "manage-forms";
      manageButtonLink = "user/jumbo-forms/form-management";
      break;
    case "picker":
      manageButton = "manage-picker";
      manageButtonLink = "inbox?t=picker";
      break;
    case "sub-users-addon":
    case "sub-users-subscription":
      manageButton = "manage-sub-users";
      manageButtonLink = "user/profile/account";
      break;
    default:
      manageButton = "manage-storage";
      manageButtonLink = "inbox?t=all&sm=saved";
      break;
  }

  return { title, description, manageButton, manageButtonLink };
};

export default getTextKeysForModal;
